import { render, staticRenderFns } from "./payCompletion.vue?vue&type=template&id=45596e1d&scoped=true"
import script from "./payCompletion.vue?vue&type=script&lang=js"
export * from "./payCompletion.vue?vue&type=script&lang=js"
import style0 from "./payCompletion.vue?vue&type=style&index=0&id=45596e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45596e1d",
  null
  
)

export default component.exports